import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import Button from 'flarum/components/Button';

import avatar from 'flarum/common/helpers/avatar';
import selectButton from "../common/util/selectButton";
import UserManageUserEditModal from "./modal/UserManageUserEditModal";
import UserLogoutConfirmationModal from "./modal/UserLogoutConfirmationModal";

export default class CategoryModule extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');

    this.userData = app.session.user;
    this.selectedCategory = window.selectedCategory = this.attrs.selectedCategory;
    this.managementCategoryList = [];

    if(u2diUserType9===true){
      this.managementCategoryList = ["tj","td","xd","fx","gg","yh"];
    }

    if(u2diUserType0===true && u2diUserType9===false){
      this.managementCategoryList = ["gg","td","fx"];
    }

    this.managementCategoryIcon = {};

    for(let index in this.managementCategoryList){
      this.managementCategoryIcon[this.managementCategoryList[index]] = -1;
    }
  }

  view() {
    const _this = this;

    if(this.userData!==null){
      const u2diUserName = this.userData.attribute("u2diUserName");
      const userInfoData = app.store.getById("u2diUserInfo",this.userData.id());
      const userSigned = userInfoData.userSigned();
      const userSuffix = userInfoData.userSuffix();
      const userEditFrom = "user";
      let u2diUserStatus = userInfoData.userStatus();
      let u2diUserExpireDays = userInfoData.expireDays();
      let u2diNoExpiration = userInfoData.noExpiration();
      let u2diUserExpireDaysText = "";

      if(u2diNoExpiration===1 && u2diUserStatus===0){
        u2diUserExpireDaysText = app.translator.trans('ziven-u2di.forum.item-user-duration-unlimit');
      }else{
        if(u2diUserStatus===0){
          u2diUserExpireDaysText = u2diUserExpireDays+app.translator.trans('ziven-u2di.lib.unit-day');
        }else if(u2diUserStatus===1){
          u2diUserExpireDaysText = app.translator.trans('ziven-u2di.forum.item-user-duration-expired');
        }else if(u2diUserStatus===2){
          u2diUserExpireDaysText = app.translator.trans('ziven-u2di.forum.item-user-duration-banned');
        }
      }
    
      const navigateOption = {
        item0: {name:app.translator.trans('ziven-u2di.forum.title-user-account'),icon:'fas fa-sliders-h',click:function(){app.modal.show(UserManageUserEditModal,{userInfoData,userEditFrom})}},
        item1: {name:app.translator.trans('ziven-u2di.forum.title-user-logout'),icon:'fas fa-sign-out-alt',click:function(){app.modal.show(UserLogoutConfirmationModal)}},
      };

      const u2diNotification = app.store.getById("u2diNotification","");

      if(u2diNotification){
        for(let index in this.managementCategoryIcon){
          if(typeof(u2diNotification[index])==="function"){
            this.managementCategoryIcon[index] = u2diNotification[index]();
          }
        }
      }

      return (
        <div className="u2diManagementContainer">
          <div className="u2diManagementItemsContainer">
            {this.managementCategoryList.map((categoryName) => {
              let className = "u2diManagementItem";

              if(this.selectedCategory===categoryName){
                className+=" u2diManagementItemSelected";
              }

              let categoryNotificationCount = this.managementCategoryIcon[categoryName];

              return (
                <div group="managementCategoryButton" className={className} onclick={(e) => selectButton(e,"u2diManagementItemSelected",function(){
                  _this.setManageCategory(categoryName);
                })}><div style={categoryNotificationCount<=0?"display:none":""} className="u2diLabelRed u2diNotificationIcon">{categoryNotificationCount}</div>{app.translator.trans('ziven-u2di.forum.manage-category-'+categoryName)}</div>
              );
            })}
            <div style="position:relative;" className="u2diManagementUser">
              <div>{avatar(this.userData)}</div>
              <div style={"padding-top:5px;"+(userSigned===0?"":"color:#A17EFF")}>
                {u2diUserName}
              </div>
              {userSuffix && (
                <div>签约：{userSuffix}</div>
              )}
              <div style="font-size: 12px;color: gray;">({u2diUserExpireDaysText})</div>
              <div style="position: absolute;right: 0px;bottom: -10px;">
                {Dropdown.component({
                    buttonClassName: 'Button u2diUserOptionoDropdown',
                    icon: "fas fa-cog"
                  },
                  Object.keys(navigateOption).map((key) => {
                    const opitonData = navigateOption[key];

                    return Button.component({
                        icon: opitonData.icon,
                        onclick: () => opitonData.click(),
                      },
                      opitonData.name
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  setManageCategory(name){
    $(window).trigger('u2diIndexPageSetManageCategory', name);
  }
}